<nav class="lib-nav">
  <span class="lib-spacer"></span>
  <h6 data-test="welcome-title-signup">{{title}}</h6>
  <span class="lib-spacer"></span>
</nav>
<figure>
  <ngx-picture class="cover" src="/assets/illustrations/signup-success-promo.svg" alt="" [lazyLoad]="true"></ngx-picture>
</figure>
<div>
  <p><span [innerHtml]="message | safe: 'html'"></span>, <strong>check&nbsp;your&nbsp;inbox</strong> and
    <strong>verify&nbsp;your&nbsp;email</strong>.</p>
    <p [hidden]="!email" class="lib-legend email">{{email}}</p>
</div>
